import { useEffect } from "react";
import { useProjectDataStore } from "stores/projectStore";
import { getProjectId } from "utils";

export const useSyncProjectId = () => {
  const projectId = useProjectDataStore((state) => state.projectId);
  const setProjectId = useProjectDataStore((state) => state.setProjectId);
  useEffect(() => {
    const paramProjectId = getProjectId();
    if (projectId !== null && projectId !== paramProjectId) {
      setProjectId(paramProjectId);
    }
  }, [projectId, setProjectId]);
};
